export enum TitleEnum {
    Blank = "",
    Mr = "Mr",
    Miss = "Miss",
    Mrs = "Mrs",
    Ms = "Ms",
    Dr = "Dr",
}
